export default "__VITE_ASSET__a58e5f16__"